module.exports = __webpack_public_path__ + "static/img/contrast_tip.c40cd4d6.png";